import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "@routing/routes";
import { SUPPORT_LINK_TEXT } from "../_helpers/noLocationCopy";

interface SupportLinkedTextProps {
    text: string;
    // For a surface that must close itself as the shopper leaves (the ship-to
    // panel's open state outlives the route).
    onLinkClick?: () => void;
}

// Renders a sentence with every "USNara support" in it as a link to the
// support page (#453). The sentences stay plain strings in noLocationCopy.ts,
// so a string-only surface reads them unchanged; a sentence without the words
// renders as plain text. `link` underlines and inherits the surrounding
// colour, so it stays readable on every surface that carries these notes.
export const SupportLinkedText = ({
    text,
    onLinkClick,
}: SupportLinkedTextProps) => (
    <>
        {text.split(SUPPORT_LINK_TEXT).map((part, index) => (
            <Fragment key={index}>
                {index > 0 && (
                    <Link
                        to={ROUTES.SUPPORT}
                        className="link"
                        onClick={onLinkClick}
                    >
                        {SUPPORT_LINK_TEXT}
                    </Link>
                )}
                {part}
            </Fragment>
        ))}
    </>
);
